import styled from 'styled-components';
import {SectionWrapper} from '../../../shared/Styles/Wrappers';
import {GlobalWrapper} from '../../../shared/Styles/Wrappers';

export const Container = styled.div`
    position: relative;
    background-color: ${({color}) => (color ? color : "transparent")};
    padding: 124px 0;

    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        padding: 64px 0;
    }
    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet}) {
        padding: 36px 0;
    }
`;

export const TitleWrapper = styled(GlobalWrapper)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    width: 100%;
    text-align: center;
    padding: 0 48px;
    @media screen and (max-width: ${({theme}) =>
            theme.breakpoints.tablet_big}) {
        padding: 0 24px;
    }
`;

export const Title = styled.h3`
    font-size: 11rem;
    color: #fff;
    font-weight: 800;
    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        font-size: 9rem;
    }
    @media screen and (max-width: ${({theme}) =>
            theme.breakpoints.tablet_big}) {
        font-size: 7rem;
    }
    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet}) {
        font-size: 6rem;
    }
    @media screen and (max-width: ${({theme}) => theme.breakpoints.phone_big}) {
        font-size: 5rem;
    }
    @media screen and (max-width: ${({theme}) => theme.breakpoints.phone}) {
        font-size: 4rem;
    }
`;

export const Column = styled.div`
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;

    &:first-child {
        padding-right: 48px;
    }

    &:last-child {
        padding-left: 48px;
    }

    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet_small}) {
        width: 100%;

        &:first-child {
            padding-right: 0;
            margin-bottom: 48px;
        }

        &:last-child {
            padding-left: 0;
        }
    }
`;

export const ImageWrapper = styled.div`
    width: 100%;
    max-width: ${({width}) => (width ? width + 'px' : '100%')};
    margin-left: auto;
    margin-right: auto;

    .gatsby-image-wrapper {
        width: 100%;
        height: auto;
    }

    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet_small}) {
        max-width: 80%;
    }
`;

export const ColumnWrapper = styled(SectionWrapper)`
    display: flex;
    flex-wrap: wrap;
`;
